import { useEffect } from "react";
import {
  selectIsConnectedToRoom,
  useAVToggle,
  useHMSStore,
} from "@100mslive/react-sdk";

function isTyping(target) {
  if (!target) {
    return false;
  }
  const tag = target.tagName;
  return (
    tag === "INPUT" ||
    tag === "TEXTAREA" ||
    tag === "SELECT" ||
    target.isContentEditable
  );
}

/**
 * Cmd/Ctrl+D toggles the microphone and Cmd/Ctrl+E the camera, only during
 * the call and never while the participant is typing (inventory 15.35).
 */
export function useKeyboardShortcuts() {
  const isConnected = useHMSStore(selectIsConnectedToRoom);
  const { toggleAudio, toggleVideo } = useAVToggle();

  useEffect(() => {
    if (!isConnected) {
      return undefined;
    }
    const onKeyDown = event => {
      if (!(event.metaKey || event.ctrlKey) || isTyping(event.target)) {
        return;
      }
      const key = event.key.toLowerCase();
      if (key === "d" && toggleAudio) {
        event.preventDefault();
        toggleAudio();
      } else if (key === "e" && toggleVideo) {
        event.preventDefault();
        toggleVideo();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isConnected, toggleAudio, toggleVideo]);
}
